export default {
  common: {
    cancel: 'Отмена',
    done: 'Готово',
    back: 'Назад',
    close: 'Закрыть',
    start: 'Начало',
    end: 'Конец',
    create: 'Создать',
    optional: 'Необязательно',
    loading: 'Загрузка..',
    undo: 'Отменить',
    delete: 'Удалить',
    notes: 'Заметки',
    save: 'Сохранить',
    more: 'Ещё',
    ok: 'OK',
    errorPrefix: 'Ошибка: {name}. {message}',
  },
  stop: {
    reason: {
      'out-of-stock': 'Закончился продукт',
      'too-busy': 'Не успеваем',
      'quality-issue': 'Проблема с качеством',
      'wait-and-retry': 'Подождать, пока освободимся',
      other: 'Другое',
    },
  },
  update: {
    title: 'Доступна новая версия',
    prompt: 'Обновить до новой версии?',
    reload: 'Перезагрузить',
    toastMessage: 'Новая версия: v{current} → v{latest}',
    toastMessageFallback: 'Доступна новая версия',
    statusUpToDate: 'Актуально',
    statusChecking: 'Проверяем…',
    statusAvailable: 'v{latest} доступна',
    checkNow: 'Проверить обновления',
    version: 'Версия приложения',
  },
  auth: {
    authenticating: 'Аутентификация..',
  },
  account: {
    title: 'Аккаунт',
    printerSettings: 'Настройки принтера',
    availablePrinters: 'Доступные принтеры',
    availableStorefronts: 'Доступные заведения',
    selectPrinter: 'Выбрать принтер',
    selectStorefront: 'Выбрать заведение',
    selectedPrinter: 'Выбранный принтер',
    groups: {
      settings: 'Настройки',
      account: 'Аккаунт',
    },
    items: {
      storefront: 'Заведение',
      pushNotifications: 'Push-уведомления',
      sendTestNotification: 'Отправить тестовое уведомление',
      version: 'Версия',
      logOut: 'Выйти',
      enabled: 'Включено',
      disabled: 'Выключено',
    },
    debugPrinter: 'Тестовый принтер',
    unknownStorefront: 'Неизвестно',
    noDate: 'Без даты',
    noTime: 'Без времени',
    printer: {
      title: 'Принтер и фискал',
      settings: 'Настройки',
      devMode: 'Dev-режим',
      receiptPreview: 'Превью чека',
      actions: 'Фискальные действия',
      printDuplicate: 'Печать дубликата',
      printXReport: 'Печать X-отчёта',
      printZReport: 'Печать Z-отчёта',
      statusLoading: 'Проверяю принтер…',
      statusNotSetUp: 'Принтер не выбран',
      statusError: 'Принтер недоступен',
      confirmZ: {
        title: 'Распечатать Z-отчёт?',
        message: 'Этот отчёт можно распечатать только один раз. Подтверди печать.',
        confirm: 'Да, распечатать',
      },
      report: {
        navRow: 'Отчёт за период',
        title: 'Отчёт за период',
        description:
          'Оборот по налоговым группам и ДДС за выбранные даты, печатается на фискальном принтере.',
        from: 'С',
        to: 'По',
        mode: 'Тип отчёта',
        detailed: 'Подробный',
        brief: 'Краткий',
        withPayments: 'Разбивка по типам платежей',
        print: 'Печать отчёта',
      },
    },
  },
  shift: {
    startShift: 'Начать смену',
    goToAccount: 'В аккаунт',
    current: 'Текущая смена',
    upcoming: 'Ближайшая смена',
    greeting: 'Привет, {name}',
    noShiftAvailable: 'Нет доступной смены',
    scheduledStarted:
      'Твоя смена была запланирована с {startTime} до {endTime}, {endDate}.',
    aboutToStart: 'Твоя смена скоро начнётся — {startDate} в {startTime}.',
    nextWillStart:
      'Следующая смена начнётся {startDate} в {startTime}. Активировать можно в приложении начиная с {activationTime}.',
  },
  dashboard: {
    title: 'Дашборд',
    loading: 'Загрузка данных..',
    noData: 'Нет данных',
    groups: {
      shifts: 'Смены',
      today: 'Сегодня',
      inProgress: 'В процессе',
    },
    items: {
      total: 'Итого',
      cash: 'Наличные',
      card: 'Карта',
    },
    shiftPage: {
      fallbackTitle: 'Смена',
      ordersGroup: 'Заказы',
      authorizeShift: 'Закрытие смены',
      stopShift: 'Завершить смену',
      items: 'позиций нет | {count} позиция | {count} позиции | {count} позиций',
    },
  },
  tabs: {
    title: 'Столы',
    noOrders: 'Заказов нет',
    unknownTabName: 'Стол без имени',
  },
  inHouse: {
    orders: 'Заказы',
    mapMove: 'Переместить',
    filters: {
      byStatus: 'По статусу',
      byZone: 'По зоне',
      everything: 'Все',
    },
    loadingOrders: 'Загрузка заказов..',
    noOrders: 'Заказов нет',
  },
  map: {
    loading: 'Загрузка карты..',
    empty: 'Карта не создана',
    selectTableToMoveTo: 'Выбери стол, на который перенести',
    moveOrderFromTo:
      'Перенести заказ со стола {fromName} на стол {toName}',
    inappropriateObject: 'Перенос на/со неподходящего объекта',
  },
  search: {
    productsPlaceholder: 'Поиск продуктов...',
    vendorsPlaceholder: 'Поиск поставщиков...',
  },
  products: {
    addProducts: 'Добавить продукты',
    notFound: 'Продукты не найдены',
    notAvailable: 'Нет доступных продуктов',
  },
  vendors: {
    changeVendor: 'Сменить поставщика',
    notFound: 'Поставщики не найдены',
    notAvailable: 'Нет доступных поставщиков',
  },
  procurement: {
    title: 'Закупки',
    newOrder: 'Новый заказ',
    loadingProducts: 'Загрузка продуктов..',
    noProductsFound: 'Продукты не найдены',
    loadingOrders: 'Загрузка заказов..',
    noOrdersYet: 'Заказов пока нет',
    orderPrefix: 'Заказ, ',
    productsCount: 'нет продуктов | {count} продукт | {count} продукта | {count} продуктов',
    filters: {
      active: 'Активные',
      past: 'Прошлые',
    },
    status: {
      backlog: 'В очереди',
      progress: 'В процессе',
      arrived: 'Прибыл',
      complete: 'Готов',
    },
    item: {
      fallbackTitle: 'Позиция',
      setVendor: 'Выбрать поставщика',
      tapToAddPhoto: 'Нажми, чтобы добавить фото',
      warnings: 'Предупреждения',
      editAmount: 'Изменить количество',
    },
    detail: {
      fallbackTitle: 'Заказ',
      orderTitle: 'Заказ, {date}',
      itemsCount: 'нет позиций | {count} позиция | {count} позиции | {count} позиций',
      noProductsYet: 'Продуктов пока нет',
      addProductsHint: 'Нажми +, чтобы добавить продукты',
      payments: 'Платежи',
      noVendor: 'Без поставщика',
      unknownVendor: 'Неизвестный поставщик',
      unknownProduct: 'Неизвестный продукт',
      noDescription: '(без описания)',
      badges: {
        primary: 'Основной',
        alternative: 'Альтернатива',
        newSupply: 'новый supply',
        newIngredient: 'новый ingredient',
      },
      pendingProduct: {
        willCreateSupply: 'Создастся новый supply',
        willCreateIngredient: 'Создастся новый ingredient',
        optOutToExpense: 'Разовая покупка — в expense',
      },
      actions: {
        unreject: 'Восстановить',
        notReceived: 'Не получено',
        reject: 'Отклонить',
        skip: 'Пропустить',
      },
      scan: {
        uploading: 'Загрузка фото…',
        parsing: 'Чтение накладной…',
        matching: 'Сопоставление позиций…',
        refreshing: 'Почти готово…',
        documentScanned: 'Документ отсканирован',
        createdVendor: 'Создан поставщик: {name}',
        scanFailed: 'Сканирование не удалось: {message}',
        matchFailed: 'Сохранено, сопоставление не удалось: {message}',
        unknownError: 'неизвестно',
        noteSheetTitle: 'Подсказка для ИИ (необязательно)',
        noteSheetHint: 'Опишите контекст, который ИИ должен учесть при разборе документа — имеет высший приоритет.',
        notePlaceholder: 'напр. Все позиции "Other Item" — это футболка размер L.',
        pickPhotos: 'Выбрать фото',
      },
    },
  },
  transaction: {
    label: 'Транзакция #{number}',
    addCash: 'Наличные',
    addCard: 'Карта',
    paid: 'Оплачено',
    pending: 'Ожидает',
    reversed: 'Отменена',
    reverse: 'Отменить',
    printReceipt: 'Фискальный чек',
    printPreCheck: 'Пре-чек',
    deleteTransaction: 'Удалить транзакцию',
    printerNotConfigured: 'Принтер не настроен',
    printerError: 'Ошибка принтера: {response}',
    printingReceipt: 'Печатаем чек…',
  },
  payment: {
    notFound: 'Платёж не найден',
    label: 'Платёж',
    save: 'Сохранить',
    paid: 'оплачено',
    pending: 'ожидает',
    date: 'Дата',
    amount: 'Сумма',
    overrideAmount: 'Изменить сумму',
    overrideHint: 'Своё значение, нужны заметки',
    computedHint: 'Расчётно: {amount} {sign}',
    requiredPlaceholder: 'Обязательно',
    overrideReasonPlaceholder: 'Почему меняем?',
    notes: 'Заметки',
    notesRequired: 'Заметки (обязательно)',
    markPaid: 'Отметить оплаченным',
    markPending: 'Отметить ожидающим',
    methods: {
      cash: 'Наличные',
      card: 'Карта',
      transfer: 'Перевод',
      other: 'Другое',
    },
  },
  order: {
    noYet: 'Заказа ещё нет',
    createHint: 'Создай заказ нажатием на кнопку.',
    createButton: 'Создать заказ',
    addMenuItem: 'Добавить позицию',
    sendToWork: 'Отправить в работу',
    checkout: 'Расчёт',
    payment: 'Оплата',
    total: 'Итого',
    paid: 'оплачено',
    transactions: 'Транзакции',
    noTransactionsYet: 'Транзакций пока нет',
    finalise: 'Закрыть заказ',
    startBatch: 'Начать партию',
    newBatch: 'Новая партия',
    controls: 'Управление',
    notLoaded: 'Заказ или позиция не загружены',
    menus: 'Меню',
    added: 'Добавлено',
    toBatch: 'В партию',
    toMenu: 'В меню',
    itemOnStop: 'На стопе',
    promotions: 'Промоушены',
    actions: {
      addOrderToTable: 'Добавить заказ к столу',
      assignToMe: 'Назначить на меня',
      reassignTo: 'Назначить на…',
      reassignPickHeader: 'Кому передать стол',
      reassignNoStaffOnShift: 'Сейчас никого нет на смене',
      restoreOrder: 'Восстановить заказ',
      cancelOrder: 'Отменить заказ',
    },
    batchLabel: 'ПАРТИЯ #{number}',
    draftBatchLabel: 'ЧЕРНОВИК ПАРТИИ',
    commentAlert: {
      header: 'Введи комментарий',
      add: 'Добавить',
      update: 'Обновить',
      placeholder: 'Введи текст',
    },
    leaveBatchAlert: {
      header: 'Точно уходим?',
      message: 'В партии есть неотправленные позиции.',
      goBack: 'Назад',
    },
    errorPrefix: 'Ошибка: {name}. {message}',
    addItemFailed: {
      noTax: 'Позиция не добавлена — не настроена налоговая группа для «{name}»',
      inconsistentState: 'Позиция не добавлена — состояние конфигуратора неконсистентно',
    },
    moveItems: {
      enter: 'Переместить',
      selectTarget: 'Выберите стол',
      submit: 'Перенести сюда',
      submitTo: 'Перенести {from} → {to}',
      cancel: 'Отмена',
      mustLeaveOne: 'Оставьте минимум 1 позицию',
      errorNotApplied: 'Перенос не выполнен',
      errorReverted: 'Перенос откачен',
      errorBroken: 'Перенос сломан — items в обоих ордерах: {ids}',
    },
    controlsPage: {
      groups: {
        status: 'Статус',
        actions: 'Действия',
      },
      markAsInProgress: 'Отметить «В процессе»',
      markAsReady: 'Отметить «Готово»',
      markAsServed: 'Отметить «Подано»',
      markAsCancelled: 'Отметить «Отменено»',
      remove: 'Удалить',
      removeLockedInCheckout:
        'Заказ на этапе оплаты — позиции заблокированы. Чтобы изменить заказ, сначала отмените оплату.',
    },
  },
  tasks: {
    title: 'Задачи',
    callsTitle: 'Вызовы',
    today: 'Сегодня',
    loadingTasks: 'Загрузка задач..',
    noTasksToday: 'Задач на сегодня нет',
    subtasksProgress: '{completed} из {total} подзадач',
    allDone: 'Всё готово!',
    detail: {
      fallbackTitle: 'Задача',
      progress: 'Прогресс',
      subtasks: 'Подзадачи',
      verification: 'Проверка',
      reference: 'Образцы',
      activation: 'Активация',
      date: 'Дата',
      shift: 'Смена',
      submitted: 'Отправлено',
      takePhoto: 'Сделать фото',
      addComment: 'Добавить комментарий',
      markAsDone: 'Отметить выполненной',
      undo: 'Отменить',
      noRulesMatched: 'Нет совпадений по правилам — показано как назначенное вручную',
      uploadFailed: 'Загрузка не удалась: {message}',
      unknownError: 'Неизвестная ошибка',
      status: {
        pending: 'Ожидает',
        'in-progress': 'В процессе',
        completed: 'Выполнено',
        skipped: 'Пропущено',
        missed: 'Не выполнено',
      },
      ruleTypes: {
        shiftTemplateId: 'Шаблон смены',
        dayOfTheWeek: 'День недели',
        dayOfTheMonth: 'День месяца',
        timeOfTheDay: 'Время суток',
        hourOfTheDay: 'Час',
        minuteOfTheHour: 'Минута',
      },
      weekdays: {
        sun: 'Вс',
        mon: 'Пн',
        tue: 'Вт',
        wed: 'Ср',
        thu: 'Чт',
        fri: 'Пт',
        sat: 'Сб',
      },
    },
    waiterCalls: {
      noRecent: 'Нет недавних вызовов',
      hint: 'Здесь появятся вызовы официанта за последние 5 минут',
      noTable: 'Без стола',
      table: 'Стол',
      tableNamed: 'Стол {name}',
      noStaff: 'Никого не позвали',
      staffCount: '{count} человек из персонала',
      calledList: 'Позвали: {names}',
      secondsAgo: '{count} сек назад',
      minutesAgo: '{count} мин назад',
    },
  },
  promotions: {
    sidebarTitle: 'Применённые промоушены',
    contentTitle: 'Добавить промоушен',
    sidebarPlaceholder: 'Добавляй промоушены справа',
    remove: 'Удалить',
    done: 'Готово',
    searchInputPlaceholder: 'Начни печатать',
    searchCancel: 'Отмена',
    searchPlaceholder: 'Начни печатать — здесь появятся результаты.',
    matchingPromotions: 'Подходящие промоушены',
    apply: 'Применить',
    applied: 'Применено',
  },
}
